import React from "react";

import styles from "./GLS.module.css";

function PurolatorGround({ data }) {
  const requiredService = data.find((d) => d.serviceID === "PurolatorGround");
  return (
    <>
      {requiredService && (
        <div className={styles.container}>
          <h2>Purolator Ground</h2>
          <div>
            <div className={styles.frightRate}>
              <div className={styles.subHeadHead}>Estimated Delivery</div>
              <div className={styles.subHeadRate}>
                {requiredService?.expectedDeliveryDate}
              </div>
            </div>
          </div>
          <div className={styles.subTotalRate}>
            <h3>Sub Total</h3>
            <div className={styles.subContainer}>
              <div className={styles.subHeadHead}>Basic Charge</div>
              <div className={styles.subHeadRate}>
                ${requiredService?.basePrice}
              </div>
            </div>
            <div className={styles.subContainer}>
              <div className={styles.subHeadHead}>Fuel Surcharge</div>
              <div className={styles.subHeadRate}>
                ${requiredService?.fuelSurcharge}
              </div>
            </div>
            <div className={styles.subContainer}>
              <div className={styles.subHeadHead}>GST/HST</div>
              <div className={styles.subHeadRate}>${requiredService?.gst}</div>
            </div>
            <div className={styles.subContainer}>
              <div className={styles.subHeadHead}>Transit Time</div>
              <div className={styles.subHeadRate}>
                {requiredService?.estimatedTransitDays} Days
              </div>
            </div>
          </div>
          <div className={styles.total}>${requiredService?.totalPrice}</div>
        </div>
      )}
      {!requiredService && (
        <div className={styles.container}>
          <div>
            <h2>Purolator Ground</h2>
            <h3
              style={{
                margin: "12px 0",
              }}
            >
              Rate not available
            </h3>
          </div>
        </div>
      )}
    </>
  );
}

export default PurolatorGround;
